export const API_REDUCER = {
  INVITATION_GROUP: 'invitationGroup',
  INVITATION_GROUP_MAPPING: 'invitationGroupMapping',
  INVITATION_KEY: 'invitationKey',
  NOTIFICATION: 'notification',
  NOTIFICATION_CONTENT: 'notificationContent',
  NOTIFICATION_CONTENT_SPECIFICATION: 'notificationContentSpecification',
  NOTIFICATION_CONTENT_TYPE: 'notificationContentType',
  NOTIFICATION_TYPE: 'notificationType',
  NOTIFICATION_QUEUE: 'notificationQueue',
};

export const COMPONENT_REDUCER = {
  RENDER_HEARING: 'renderHearing',
  COMMENT_SECTION: 'commentSection',
  HEARING_OVERVIEW: 'hearingOverview',
  NOTIFICATION_PANEL: 'notificationPanel',
};
